import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { ExpertModeTheme } from "../../theme/expert-mode"
import imageArrowLeftRight from "../../../public/img/arrowLeftRight.svg"
import imageArrowLeftRightHighlight from "../../../public/img/arrowLeftRight-highlight.svg"

const Root = styled.div(css`
    display: flex;
    justify-content: space-between;
    gap: 20px;
`)

const Step = styled.div<{ expertTheme: ExpertModeTheme, isSelected: boolean }>(
    css`
        width: 100%;
        border-radius: 8px;
        font-family: inter-regular;
        padding: 16px;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        `,
    props => props.isSelected ?
        css`
            background-color: ${props.expertTheme.colors.primary};
            color: ${props.expertTheme.colors.textHighlight};
        ` :
        css`
            background-color: ${props.expertTheme.colors.primaryLight};
            color: ${props.expertTheme.colors.text};
        `)

const Label = styled.div(
    css`
        font-size: 24px;
        font-weight: 700;
        font-style: normal;
        line-height: 34px;
    `)

const SubLabel = styled.div(
    css`
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        display: flex;
    `)

const Icon = styled.img(
    css`
        width: 24px;
        height: 24px;
        margin-left: 5px;
    `)

const ImgArrow = styled.img<{ expertTheme: ExpertModeTheme, isSelected: boolean }>(
    css`
        margin-right: 10px;
        margin-left: 10px;
    `)

const SubState = styled.div<{ expertTheme: ExpertModeTheme }>(
    props => css`
        background-color: ${props.expertTheme.colors.highlight};
        height: 35px;
        color:  ${props.expertTheme.colors.text};
        font-weight: 600;
        font-size: 14px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        box-sizing: border-box;
`)

const MainInfo = styled.div(css``)

type Step<Id> = {
    id: Id,
    label: string,
    fromLabel: string,
    toLabel: string;
}

type Props<Id = unknown> = {
    expertTheme: ExpertModeTheme,
    steps: Array<Step<Id>>,
    currentStep: Id,
    subState?: { text: string, icon?: string }
}

const StepIndicator = <Id extends string>({ expertTheme, steps, currentStep, subState }: Props<Id>) => (
    <Root>
        {steps.map(step => {
            const isSelected = currentStep === step.id

            return (
                <Step key={step.id} {...{ expertTheme, isSelected }}>
                    <MainInfo>
                        <SubLabel>
                            {step.fromLabel}
                            <ImgArrow {...{ expertTheme, isSelected }}
                                src={isSelected ? imageArrowLeftRightHighlight.src : imageArrowLeftRight.src} />
                            {step.toLabel}
                        </SubLabel>
                        <Label>{step.label}</Label>
                    </MainInfo>
                    {isSelected && subState &&
                        <SubState {...{ expertTheme }}>
                            {subState.text}
                            {subState.icon && <Icon src={subState.icon} />}
                        </SubState>
                    }
                </Step>
            )
        })}
    </Root >
)

export default StepIndicator